import { z } from 'zod';

const passwordSchema = z.string().min(6, { message: 'Password must be at least 6 characters long' });
const emailSchema = z.string().email({ message: 'Invalid email address' });

export const signupSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  email: emailSchema,
  password: passwordSchema,
  invitationToken: z.string().optional(),
});

export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  // not used but included for typescript compatibility
  name: z.string().optional(),
  invitationToken: z.string().optional(),
});

export const emailOnlySchema = z.object({
  email: emailSchema,
});

export const resetPasswordSchema = z.object({
  password: passwordSchema,
});
